import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PackageCheck, Loader2, AlertTriangle } from "lucide-react";

export default function ScanConsignment() {
  const { cid } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/public/consignment/${cid}`).then(({ data }) => setData(data)).catch(() => setErr(true));
  }, [cid]);

  if (err) return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="text-center text-slate-500" data-testid="scan-not-found">
        <AlertTriangle className="w-10 h-10 mx-auto mb-2 text-amber-500" />
        Barang titipan tidak ditemukan atau sudah dihapus.
      </div>
    </div>
  );
  if (!data) return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <Loader2 className="w-6 h-6 animate-spin text-slate-400" />
    </div>
  );

  const di = data.status === "DI_FOMU";
  return (
    <div className="min-h-screen bg-slate-50 py-8 px-4" data-testid="scan-consignment-page">
      <div className="max-w-md mx-auto bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <div className="bg-[#184f44] text-white p-5">
          <div className="flex items-center gap-2 text-sm opacity-90"><PackageCheck className="w-4 h-4" /> {data.company_name} · Barang Titipan</div>
          <div className="text-2xl font-bold mt-1" data-testid="scan-code">{data.code}</div>
          <span className={`inline-block mt-2 text-xs font-semibold px-2.5 py-1 rounded-md ${di ? "bg-emerald-400 text-emerald-950" : "bg-slate-200 text-slate-700"}`} data-testid="scan-status">{data.status_label}</span>
        </div>
        <div className="p-5 space-y-4">
          <div>
            <div className="text-[11px] font-mono uppercase text-slate-400">Penitip</div>
            <div className="font-semibold text-slate-800" data-testid="scan-customer">{data.customer_name || "-"}{data.company ? ` · ${data.company}` : ""}</div>
            <div className="text-sm text-slate-500">HP: {data.whatsapp || "-"}</div>
            <div className="text-sm text-slate-500">Tgl titip: {data.received_at || "-"}{di && data.days_at_fomu > 0 ? ` · ${data.days_at_fomu} hari di FOMU` : ""}</div>
          </div>
          <div>
            <div className="text-[11px] font-mono uppercase text-slate-400 mb-1.5">Barang ({data.items.length})</div>
            <div className="divide-y divide-slate-100 border border-slate-100 rounded-lg" data-testid="scan-items">
              {data.items.map((it, i) => (
                <div key={i} className="flex items-center justify-between px-3 py-2 text-sm">
                  <span className="text-slate-700">{it.name} <span className="text-slate-400">×{it.qty}</span></span>
                  <span className={`text-xs ${it.condition === "Baik" ? "text-emerald-600" : "text-amber-600"}`}>{it.condition}</span>
                </div>
              ))}
            </div>
          </div>
          {data.notes && <div className="text-sm text-slate-500"><b>Catatan:</b> {data.notes}</div>}
        </div>
      </div>
    </div>
  );
}
